import { IonGrid, IonIcon, IonItem, IonLabel } from '@ionic/react'
import { chatboxOutline } from 'ionicons/icons'
import React from 'react'
import './Comment.component.css'
import { useHistory } from 'react-router'
import { useTranslation } from 'react-i18next'

interface ICommentProps {
  isDataPresent: boolean
  path: string
  isFieldComment?: boolean
}
const Comment: React.FC<ICommentProps> = ({ isDataPresent, path, isFieldComment }) => {
  const history = useHistory()
  const { t } = useTranslation()
  return (
    <IonItem
      lines='none'
      id='commentContent'
      className='ion-no-padding ml-16'
      onClick={() => history.push(path, isFieldComment)}>
      <IonGrid className='commentAlign ion-no-padding'>
        <IonIcon className='mr-5' color='medium' size='large' icon={chatboxOutline} />
        <div className={isDataPresent ? 'icon-dot' : ''} />
        <IonLabel color='medium'>{t('common.Comments')}</IonLabel>
      </IonGrid>
    </IonItem>
  )
}

export default Comment
